import { GuestlistTeam } from '../Tournament/Guestlist';

export const isUserInAggregatedList = (
  uid: string,
  aggregatedList: GuestlistTeam<Date>[] = [],
) => {
  return aggregatedList.find((team) => {
    return team.acceptedUserIds?.includes(uid);
  });
};
